import axios from 'axios'
import { isSSR } from '../utils/ssrUtils'

let userGeoPromise

async function getUserGeo() {
  if (isSSR()) return Promise.resolve()
  try {
    if (localStorage.getItem('userGeo')) {
      return JSON.parse(localStorage.getItem('userGeo'))
    }

    userGeoPromise =
      userGeoPromise ||
      axios.get(
        'https://ipapi.co/json?key=nrzpqZaww75gymta3AfQy1MajZv13eI7oSjL4yBiF2YL9pTiXQ'
      )

    const response = await userGeoPromise
    localStorage.setItem('userGeo', JSON.stringify(response.data))
    return response.data
  } catch (error) {
    console.error('Error getting user geo: ', error)
    localStorage.removeItem('userGeo')
    return {}
  }
}

export default getUserGeo
